/*
 * CorrespondenceControl module
*/

rs.module("controls/workflow/correspondence",

    [
        "common/visibility",
        "framework/content/workflow/step"
    ],

    function (visibility, workflowStep) {

        //
        // Initialize
        //
        function initialize(jsSelectors, actions, deliveryMethods) {

            var form = $.js(jsSelectors.form);

            var action = form.js(jsSelectors.action);
            var deliveryMethod = form.js(jsSelectors.deliveryMethod);

            // Customize jquery validation to conditionally apply validations based on
            // the chosen step action (Update or Complete)
            _setupCustomValidation();

            // Action (Save for Review or Distribute) has changed
            action.on("change", function () {

                var selectedAction = $(this).val();

                // Get the different distribution sections, optional because configuration dictates if they exist
                var distributeSection = form.js(jsSelectors.distributeSection, { required: false });
                var reviewSection = form.js(jsSelectors.saveForReviewSection, { required: false });

                // Toggle visibility of the sections based on the chosen value
                visibility.setVisible(distributeSection, selectedAction == actions.Distribute);
                visibility.setVisible(reviewSection, selectedAction == actions.SaveForReview);
            });

            // Delivery method (Email or Print) has changed 
            deliveryMethod.on("change", function () {

                var deliveryValue = $(this).val();

                // Show/hide the email fields based on email delivery being chosen
                visibility.setVisible(form.js(jsSelectors.emailIndicator, { required: false, multiple: true }),
                    (deliveryValue & deliveryMethods.email) == deliveryMethods.email)

                // Show/hide the print fields based on print delivery being chosen
                visibility.setVisible(form.js(jsSelectors.printIndicator, { required: false, multiple: true }),
                    (deliveryValue & deliveryMethods.print) == deliveryMethods.print)
            });

            // Change handler for stepAction
            workflowStep.onStepActionChanged(function (value) {
                _updateValidationScope(value == workflowStep.stepActions.Complete);
            });

            // Update the data-val property of the validationScope element so 
            // the custom jquery validation "ignore" function can look at it
            function _updateValidationScope(validate) {
                $.js(jsSelectors.validationScope).data("val", validate);

                // Set the html attribute for data-val so css can see it
                $.js(jsSelectors.validationScope).attr('data-val', validate);
            }

            // Customize jqueryvalidation to possibly skip client-side validations if
            // the validationScope is configured to not validate its children
            function _setupCustomValidation() {
                var currentIgnoreFunction = $.validator.defaults.ignore;

                var overrides = {
                    ignore: function (index, element) {

                        var result = false;

                        if (currentIgnoreFunction) {
                            result = currentIgnoreFunction(index, element);
                        }

                        if (!result) {

                            var validationScope = $(element).closestjs(jsSelectors.validationScope, { required: false });
                            if (validationScope.length > 0) {
                                result = validationScope.data("val") == false
                            }
                        }

                        return result;
                    }
                }

                // merge our overrides into the current active defaults
                $.validator.setDefaults(overrides);
            }
        }


        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);